// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"ReadMoreButton_buttonsWrapper__rt69g","button":"ReadMoreButton_button__3mZQb"};